import { render, staticRenderFns } from "./platformAnnouncementDetails.vue?vue&type=template&id=59beba2e&"
import script from "./platformAnnouncementDetails.vue?vue&type=script&lang=js&"
export * from "./platformAnnouncementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports